import { JSX } from 'react';
import Icons from 'components/atoms/Icons';

type SwiperProps = {
  numberOfItems: number;
  index: number;
  backgroundcolor: string;
  setIndex: (a: number) => void;
  handleLeft: (index?: number) => void;
  handleRight: () => void;
  setLooping: (l: boolean) => void;
};

const Swiper = (props: SwiperProps): JSX.Element => {
  if (!props) return <></>;
  const itemNumbers = Array<number>();

  const handlePrevious = () => {
    if (props.index > 0) {
      props.setIndex(props.index - 1);
      props.handleRight();
    }
  };

  const handleNext = () => {
    if (props.index < props.numberOfItems - 1) {
      props.setIndex(props.index + 1);
      props.handleLeft();
    }
  };

  const handleIndicator = (num: number) => {
    if (props.index == props.numberOfItems - 1 && num == 0) {
      props.setLooping(true);
    }
    props.setIndex(num);
  };

  for (let i = 0; i <= props.numberOfItems - 1; i++) {
    itemNumbers.push(i);
  }

  const currentPage = props.index;

  return (
    <div className={`swiper ${props.backgroundcolor.toLowerCase()}`}>
      <ul className="arrows">
        <li className="arrow-btn" key={-1}>
          <button
            type="button"
            className="swiper-btn previous"
            onClick={handlePrevious}
            disabled={currentPage === 0}
            aria-label="Previous slide"
          >
            <Icons id="chevron-left-icon" />
          </button>
        </li>
        <li className="arrow-btn" key={itemNumbers.length}>
          <button
            type="button"
            className="swiper-btn next"
            onClick={handleNext}
            disabled={currentPage === props.numberOfItems - 1}
            aria-label="Next slide"
          >
            <Icons id="chevron-left-icon" />
          </button>
        </li>
      </ul>
      <ul className="indicators">
        {itemNumbers.map(num => (
          <li
            key={num}
            className={`indicator ${currentPage === num ? 'active' : ''}`}
            onClick={() => handleIndicator(num)}
          >
            <div className="dot"></div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Swiper;
